import { render, staticRenderFns } from "./calendar-modal-add.vue?vue&type=template&id=4ad56f90&scoped=true"
import script from "./calendar-modal-add.vue?vue&type=script&lang=js"
export * from "./calendar-modal-add.vue?vue&type=script&lang=js"
import style0 from "./calendar-modal-add.vue?vue&type=style&index=0&id=4ad56f90&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad56f90",
  null
  
)

export default component.exports